import { TripStep } from "../../interfaces/trip-step.interface"
import { isDefined } from "../is-defined"
import { TripStepDetailsByFoot } from "../../interfaces/trip-step-details-foot.interface"

export const isWalk = (
  step: TripStep
): step is TripStep<TripStepDetailsByFoot> =>
  isDefined((step.details as TripStepDetailsByFoot).footsteps)
